import React, {useEffect, useState} from "react";
import "antd/dist/antd.css";
import {Carousel} from "antd";
import "./PictureSlide.css";
import {getRequest} from "../../util/APIUtils";
import {showAxiosError, createImageUrl} from "../../util/Helpers";
import {useHistory} from "react-router-dom";

function ImageSlide() {
    let history = useHistory();
    const [campaigns, setCampaigns] = useState();

    useEffect(() => {
        if (!campaigns) {
            getRequest(`/campaign/getAllCampaignsForSidebar`).then((response) => {
                setCampaigns(response.data);
            }).catch((error) => {
                showAxiosError(error.response)
            })
        }
    })

    return (
        <Carousel autoplay>
            {campaigns && campaigns.length > 0 && campaigns.map((campaign, index) => {
                return (
                    <div key={index}>
                        <img className="slide-picture" src={createImageUrl(campaign, "campaignImage")} alt=""
                             onClick={() => {
                                 history.push(`/Kampanya-Detay/${campaign.recordId}`);
                             }}/>
                    </div>
                );
            })}
        </Carousel>
    )
}

export default ImageSlide;



// WEBPACK FOOTER //
// ./src/component/PictureSlide/index.js